import IContractMemberEntity from "../../interfaces/icontract_member_entity.type";

export default class ContractMemberEntity {
   private readonly contractId: string | undefined;
   private readonly admin: boolean | undefined;
   constructor(
      contractMemberProperties: IContractMemberEntity
   ) {
      this.contractId = contractMemberProperties.contract_id;
      this.admin = contractMemberProperties.admin;
   }
   getContractId = () => this.contractId;
   getAdmin = () => this.admin;
   toObject = () => ({
      contractId: this.getContractId(),
      admin: this.getAdmin()
   });
}
